// extracted by mini-css-extract-plugin
export default {"card1":"Referral_card1__p-stl","card2":"Referral_card2__sjCtD","card3":"Referral_card3__SJKHP","card4":"Referral_card4__O0RoX","card5":"Referral_card5__3zoSP"};